<template>
  <Layout>
    <div class="bloco">
      <div class="cabecalho">
        <div class="row">
          <div class="col-md-11">
            <div class="titulo">Relatório Receitas - SIAGRO</div>
            <div class="subTitulo">Gere aqui o arquivo de movimentação de Receituário - SIAGRO</div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="borda"></div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-md-3 col-lg-2">
            <b-form-group id="input-group-data-inicial" label="Data Inicial">
              <date-picker id="input-data-inicial" v-model="estoqueRequest.data_inicial" :first-day-of-week="0"
                format="YYYY-MM-DD" value-type="format" lang="pt-br" placeholder="yyyy-mm-dd"
                :class="{ empty: isSubmit && estoqueRequest.data_inicial === '' }"></date-picker>
            </b-form-group>
          </div>

          <div class="col-12 col-md-3 col-lg-2">
            <b-form-group id="input-group-data-final" label="Data Final">
              <date-picker id="input-data-final" v-model="estoqueRequest.data_final" :first-day-of-week="0"
                format="YYYY-MM-DD" value-type="format" lang="pt-br" placeholder="yyyy-mm-dd"
                :class="{ empty: isSubmit && estoqueRequest.data_final === '' }"></date-picker>
            </b-form-group>
          </div>

          <div class="col-md-4">
            <button class="btn btn-webreceita" @click="getCsv">Gerar</button>
          </div>
        </div>
      </div>

      <loading :active.sync="isLoading" color="#008e75" :can-cancel="false"></loading>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/locale/pt-br'
import 'vue2-datepicker/index.css'
import reportsService from '@/src/services/reports/reports'

export default {
  components: { Layout, Loading, DatePicker },
  data() {
    return {
      isLoading: false,
      estoqueRequest: {
        data_inicial: '',
        data_final: '',
      },
      isSubmit: false,
    }
  },
  watch: {
    estoqueRequest: {
      handler() {
        this.isSubmit = false
      },
      deep: true,
    },
  },
  methods: {
    isValidRange() {
      if (!this.estoqueRequest.data_inicial || !this.estoqueRequest.data_final) {
        return false
      }

      const start = new Date(`${this.estoqueRequest.data_inicial}T00:00:00`)
      const end = new Date(`${this.estoqueRequest.data_final}T00:00:00`)
      return start.getTime() <= end.getTime()
    },
    escapeCsv(value) {
      if (value === null || value === undefined) return ''
      const str = String(value)
      if (str.includes(',') || str.includes('"') || str.includes('\n')) {
        return `"${str.replace(/"/g, '""')}"`
      }
      return str
    },
    arrayToCsv(rows) {
      if (!rows.length) return ''

      const headers = Array.from(
        rows.reduce((set, row) => {
          Object.keys(row || {}).forEach((key) => set.add(key))
          return set
        }, new Set())
      )

      const lines = rows.map((row) =>
        headers.map((header) => this.escapeCsv(row ? row[header] : '')).join(',')
      )

      return [headers.join(','), ...lines].join('\n')
    },
    resolveCsvContent(payload) {
      if (!payload) return ''

      if (typeof payload === 'string') {
        return payload
      }

      if (Array.isArray(payload)) {
        return this.arrayToCsv(payload)
      }

      if (Array.isArray(payload.dados)) {
        return this.arrayToCsv(payload.dados)
      }

      if (Array.isArray(payload.data)) {
        return this.arrayToCsv(payload.data)
      }

      return this.arrayToCsv([payload])
    },
    downloadCsv(content) {
      const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'receita.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },
    getCsv() {
      if (!this.isValidRange()) {
        this.isSubmit = true
        this.$bvToast.toast('Informe data inicial e final validas (inicial menor ou igual a final).', {
          variant: 'danger',
          solid: false,
          noCloseButton: true,
          toaster: 'b-toaster-top-center',
        })
        return
      }

      this.isLoading = true
      const token = this.$store.state.auth.currentUser.token

      reportsService
        .reportSiagro(token, this.estoqueRequest.data_inicial, this.estoqueRequest.data_final)
        .then((response) => {
          const csvContent = this.resolveCsvContent(response.data)

          if (!csvContent) {
            this.$bvToast.toast('A API nao retornou dados para gerar o arquivo.', {
              variant: 'warning',
              solid: false,
              noCloseButton: true,
              toaster: 'b-toaster-top-center',
            })
            return
          }

          this.downloadCsv(csvContent)
        })
        .catch((err) => {
          const message =
            (err.response && err.response.data && (err.response.data.msg || err.response.data.message)) ||
            'Ocorreu um erro ao gerar o arquivo SIAGRO.'

          this.$bvToast.toast(message, {
            variant: 'danger',
            solid: false,
            noCloseButton: true,
            toaster: 'b-toaster-top-center',
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    },
  },
}
</script>

<style>
.empty {
  border: 1px solid red;
}

.controls-row {
  justify-content: flex-start;
  align-items: flex-end;
}

.controls-row .form-group {
  margin-bottom: 0;
}

.btn-gerar {
  min-width: 110px;
  height: 38px;
}
</style>
